import { z } from 'zod';

export const UpdateApprovalReminderSettingsSchema = z.object({
  enabled: z.boolean(),
  firstAfterDays: z.number().int().min(1).max(30),
  repeatEveryDays: z.number().int().min(1).max(30),
  maxReminders: z.number().int().min(1).max(10),
});
export type UpdateApprovalReminderSettings = z.infer<typeof UpdateApprovalReminderSettingsSchema>;

export interface ApprovalReminderSettingsDto {
  hotelId: string;
  enabled: boolean;
  firstAfterDays: number;
  repeatEveryDays: number;
  maxReminders: number;
  updatedAt: string | null;
}
